module.exports = __webpack_public_path__ + "static/media/settings.39eea1ee.svg";